import http from '../../../../api/http'

const BASE_URL = '/admin/jobFair';
const API_URL = `${BASE_URL}/resume`;

// 상시채용관 현황 > 학생/취업준비생 > [TAB]이력서 > 이력서 목록 조회
function retrieveJobFairResumeListAdminPaging(paramObj) {
  return http.post(`${API_URL}/retrieveJobFairResumeListAdminPaging`, paramObj);
}

// 기업상세 > 입사지원 목록 조회
function retrieveResumeListByJobNoticeSeqAdminPaging(paramObj) {
  return http.post(`${API_URL}/retrieveResumeListByJobNoticeSeqAdminPaging`, paramObj);
}

export default {
  retrieveJobFairResumeListAdminPaging,
  retrieveResumeListByJobNoticeSeqAdminPaging,
}

